export const SEARCHMODE_PARAMNAME = 'searchMode';
